import { createAction } from '@reduxjs/toolkit';

export const updateAgreementPolicy = createAction<boolean>('agreement/UPDATE_POLICY');
